import { render, staticRenderFns } from "./Split.vue?vue&type=template&id=e0688b5e&scoped=true&lang=pug"
import script from "./Split.vue?vue&type=script&lang=js"
export * from "./Split.vue?vue&type=script&lang=js"
import style0 from "./Split.vue?vue&type=style&index=0&id=e0688b5e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0688b5e",
  null
  
)

export default component.exports